import React from 'react';
import PropTypes from 'prop-types';
import { Header, Segment, List, Label } from 'semantic-ui-react';
import Highlighter from 'react-highlight-words';
import { Link } from 'react-router-dom';

const subdominios = {
  linguisticaAplicada: 'Lingüística Aplicada',
  literatura: 'Literatura',
  biblioteconomia: 'Biblioteconomía',
  cienciasDeLaSalud: 'Ciencias de la Salud',
  biologia: 'Biología',
  sociologia: 'Sociología',
  educacion: 'Educación',
  economiaYEmpresa: 'Economía y empresa',
  ingenieria: 'Ingeniería',
  informaticaYElectronica: 'Informática y electrónica',
  cienciasDeLaTierra: 'Ciencias de la Tierra',
  fisicaYQuimica: 'Física y química'
};

const labelStyle = {
  cursor: 'default',
  marginBottom: '4px'
};

const sampleSourceStyle = {
  marginTop: '8px',
  whiteSpace: 'pre'
};

const separator = ' |   ';

const buildSubdominio = titulo => {
  // Lingüitica aplicada
  if (titulo.startsWith('SPAL')) {
    return separator.concat(subdominios.linguisticaAplicada);
  }

  // Literatura
  if (titulo.startsWith('SPLIT') || titulo.startsWith('SUBLINIT')) {
    return separator.concat(subdominios.literatura);
  }

  // Biblioteconomía
  if (titulo.startsWith('ISSP')) {
    return separator.concat(subdominios.biblioteconomia);
  }

  // Ciencias de la salud
  if (
    titulo.startsWith('SUBMEDSA') ||
    titulo.startsWith('SPO') ||
    titulo.startsWith('SPHAE')
  ) {
    return separator.concat(subdominios.cienciasDeLaSalud);
  }

  // Biología
  if (titulo.startsWith('SUBIAM')) {
    return separator.concat(subdominios.biologia);
  }

  // Solciología
  if (titulo.startsWith('SPSOC')) {
    return separator.concat(subdominios.sociologia);
  }

  // Educación
  if (titulo.startsWith('SUBEDU')) {
    return separator.concat(subdominios.educacion);
  }

  // Economía y empresa
  if (titulo.startsWith('SPBM')) {
    return separator.concat(subdominios.economiaYEmpresa);
  }

  // Ingeniería
  if (titulo.startsWith('SUBINGE') || titulo.startsWith('SPME')) {
    return separator.concat(subdominios.ingenieria);
  }

  // Informática y electrónica
  if (titulo.startsWith('SUBINFEL')) {
    return separator.concat(subdominios.informaticaYElectronica);
  }

  // Ciencias de la Tierra
  if (titulo.startsWith('SPES')) {
    return separator.concat(subdominios.cienciasDeLaTierra);
  }

  // Física y química
  if (titulo.startsWith('SUBFISQUI')) {
    return separator.concat(subdominios.fisicaYQuimica);
  }
};

//Se introduce un subtema en blanco ('*') para que si existen todos los subtemas en una fórmula no aparezca el tema en su lugar. 
const temasSubtemas = Object.freeze({
    'Arte y Humanidades': [
      'Arte', 'Información y Documentación', 'Lingüística', 'Literatura', 
      'Lengua y Literatura', 'Biblioteconomía y documentación', 'Historia y Cultura','*'
    ],
    'Biología y Ciencias de la Salud' : [
      'Biología', 'Medicina','*'
    ],
    'Ciencias Físicas': [
      'Física y Química', 'Geología y Geografía', 'Informática', 'Ingeniería mecánica', 'Química', 'Ingeniería', 'Física','*'
    ],
    'Ciencias Sociales': [
      'Economía', 'Educación', 'Sociología', 'Economía y empresa','*'
    ]
});

class QualitativeDetails extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      tags: [],
      funcionesDiscursivas: [],
      funcionDiscursiva: '',
      renderFuncionesDiscursivas: false,
      showEmptyResult: false
    };
  }

  UNSAFE_componentWillReceiveProps = nextProps => {
    const grupos = this.agruparPorTemas(nextProps.formula.temas, nextProps.formula.tipoCorpus);
    const tags = this.obtenerTags(grupos);

    this.setState({ tags });
  };

  agruparPorTemas = datos => {
    const grupos = {};

    datos.forEach(dato => {
      if (!(dato.tema in grupos)) {
        grupos[dato.tema] = [];
      }
      if (!grupos[dato.tema].includes(dato.subtema)) {
        grupos[dato.tema].push(dato.subtema);
      }
    });
    return grupos;
  };

  containsAll = (needles, haystack) => {
    for (let i = 0, len = needles.length; i < len; i++) {
      if (haystack.indexOf(needles[i]) === -1) return false;
    }
    return true;
  };

  obtenerTags = grupos => {
    let tags = [];

    Object.keys(grupos).forEach(tema => {
      const relacion = temasSubtemas[tema];

      // si aparecen todos los subtemas del tema, sólo mostramos el tema
      if (relacion && relacion.length === grupos[tema].length) {
        tags.push(tema);
      } else tags = tags.concat(grupos[tema]);
    });

    // si aparece en todos los temas, sólo mostramos "Todos"
    if (this.containsAll(Object.keys(temasSubtemas), tags)) tags = ['Todos'];

    return tags;
  };

  render() {
    if(this.props.formula.comentario===undefined||!this.props.formula.comentario){this.props.formula.comentario = ''}
    const { Discursivas, Variantes, Ejemplos } = this.props.formula;
    const coment = 
      <Segment key={1} color="blue">
        <Highlighter
          highlightClassName="resaltado-texto"
          highlightStyle={{ backgroundColor: 'white' }}
          searchWords={[]}
          autoEscape={true}
          textToHighlight={this.props.formula.comentario}
        />
      </Segment>;
            
    return (
      <div>
        <Header as="h3" block attached="top" color="blue">
          Detalles de la fórmula
        </Header>
        <Segment attached>
          {Discursivas.length > 0 && <h3>Funciones discursivas</h3>}
          <List divided selection>
            {Discursivas.map(discursiva => (
              <Label key={discursiva.id} 
                  color="green" 
                  style={labelStyle}
                  as={Link}
                  className={'mystyle9'}
                  target="_blank"
                  to={`/discursiva/${discursiva.texto}`}>
                {discursiva.texto}
              </Label>
            ))}
          </List>

          {Variantes.length > 0 && <h3>Variantes</h3>}
          <List divided selection>
            {Variantes.map(variante => (
              <Label key={variante.id} basic style={labelStyle}>
                {variante.texto}
              </Label>
            ))}
          </List>

          <h3>Dominio</h3>
          {this.state.tags.length === 0 && <p>Ningún dominio asociado</p>}
          {this.state.tags.map((tag, key) => (
            <Label basic style={labelStyle} key={key}>
              {tag}
            </Label>
          ))}

          {this.props.formula.comentario ? <h3>Comentario</h3> : ''}
          {this.props.formula.comentario ? coment : ''}       
          
          {Ejemplos.length > 0 && <h3>Ejemplos</h3>}
          {Ejemplos.map(ejemplo => (
            <Segment key={ejemplo.id} color="blue">
              <Highlighter
                highlightClassName="resaltado-texto"
                highlightStyle={{ backgroundColor: 'white' }}
                searchWords={[this.props.formula.texto]}
                autoEscape={true}
                textToHighlight={ejemplo.texto}                 
              />
              <p style={sampleSourceStyle}>
                {ejemplo.titulo} &nbsp; {buildSubdominio(ejemplo.titulo)}
              </p>
            </Segment>
          ))}
        </Segment>
      </div>
    );
  }
}

QualitativeDetails.propTypes = {
  formula: PropTypes.shape({
    //texto: PropTypes.string.isRequired,
    /*temas: PropTypes.arrayOf(
      PropTypes.shape({
        subtema: PropTypes.string.isRequired,
        tema: PropTypes.string.isRequired
      }).isRequired
    ).isRequired,*/
    Discursivas: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        texto: PropTypes.string.isRequired
      })
    ).isRequired,
    Variantes: PropTypes.array.isRequired,
    Ejemplos: PropTypes.arrayOf(
      PropTypes.shape({
        FormulaId: PropTypes.number.isRequired,
        id: PropTypes.number.isRequired,
        texto: PropTypes.string.isRequired,
        titulo: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired
};

export default QualitativeDetails;
